var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #c3fe49 } \r\n\t\t.s1 { fill: #c2d234 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m487.7 195.4l-77.3-63.3v-59.6c0-7.9-6.4-14.3-14.3-14.3h-76l-61.1-50c-5.3-4.3-12.8-4.3-18.1-0.1l-62.1 50.1h-78.4c-7.9 0-14.3 6.4-14.3 14.3v60.5l-77.4 62.3c-3.4 2.7-5.3 6.8-5.3 11.2v273.5c0 7.9 6.4 14.3 14.3 14.3h460.9c7.9 0 14.3-6.4 14.3-14.3v-273.5c0.1-4.3-1.9-8.4-5.2-11.1zm-345.7 141.1l-109.9 109.1v-207.1zm21.4 19.1l75.2 67.1c2.7 2.4 6.1 3.6 9.5 3.6 3.4 0 6.8-1.2 9.5-3.6l75.2-67.1 110.9 110.1h-391.2zm191-19.1l109.9-98v207.1zm102.1-129.6l-46.1 41.1v-78.9zm-206.7-169.2l25 20.5h-50.3zm131.9 49.1v186.9l-133.5 119-133.6-119v-186.9zm-295.7 161.3l-46-41.1 46-37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m158.8 143.6h178.7c7.9 0 14.3-6.4 14.3-14.3 0-7.9-6.4-14.3-14.3-14.3h-178.7c-7.9 0-14.3 6.4-14.3 14.3 0 7.8 6.4 14.3 14.3 14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m158.8 190.9h61.3c7.9 0 14.3-6.4 14.3-14.3 0-7.9-6.4-14.3-14.3-14.3h-61.3c-7.9 0-14.3 6.4-14.3 14.3 0 7.9 6.4 14.3 14.3 14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m337.5 162.2h-61.3c-7.9 0-14.3 6.4-14.3 14.3 0 7.9 6.4 14.3 14.3 14.3h61.3c7.9 0 14.3-6.4 14.3-14.3 0.1-7.9-6.4-14.3-14.3-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m158.8 238.7h61.3c7.9 0 14.3-6.4 14.3-14.3 0-7.9-6.4-14.3-14.3-14.3h-61.3c-7.9 0-14.3 6.4-14.3 14.3 0 7.9 6.4 14.3 14.3 14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m337.5 210h-61.3c-7.9 0-14.3 6.4-14.3 14.3 0 7.9 6.4 14.3 14.3 14.3h61.3c7.9 0 14.3-6.4 14.3-14.3 0.1-7.8-6.4-14.3-14.3-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m158.8 286.5h178.7c7.9 0 14.3-6.4 14.3-14.3 0-7.9-6.4-14.3-14.3-14.3h-178.7c-7.9 0-14.3 6.4-14.3 14.3 0 7.9 6.4 14.3 14.3 14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1f3834d82798d52ef89f4888d05563d8.svg";
export { ForwardRef as ReactComponent };